/**
 * Fetches the sourcecode from the URL
 *
 * @return {string} The actual sourcecode or null if there is none
 */
const fetchSourceCodeFromUrl = () => {
  const urlString = window.location.search;
  const sourcecodeArray = urlString.match(
    "(?:^\\?|&)pc=((?:[a-zA-Z]{3}|[a-zA-Z][0-9]{2})[0-9]{6})(?:&|$)"
  );

  if (sourcecodeArray !== null) {
    return sourcecodeArray[1];
  }

  return false;
};

export default fetchSourceCodeFromUrl;
